module.exports = __webpack_public_path__ + "static/media/sizeSelect_img.52673ea9.png";